import './dynamicImport/load__federation__';
// @ts-ignore handled by custom esbuild plugin
import version from "myop-sdk-version";

console.log('myop root sdk - loaded', document.location.origin);

// TODO : read value from window['__federation__'] ?
//const __ROOT_SDK_PUBLIC_URL__ = 'https://dfdlk2p1m187v.cloudfront.net/myop_sdk.min.js'
const __ROOT_SDK_PUBLIC_URL__ = 'https://cdn.myop.dev/sdk/next/myop_sdk.min.js'

const getHostModule = () => import('./host/hostSDK')
const getIframeModule = () => import('./Iframe/IframeSDK')
const getWebcomponentModule = () => import('./webcomponent/WebComponentSDK')
const getMyopMessages = () => import('./messages/MyopMessages')
const getMyopHelpers = () => import('./helpers/MyopHelpers')

const exposeGlobally = (importFunction: () => Promise<any>) => {
    // @ts-ignore
    return async () => (await importFunction()).get()
}

// For script/global usage :
const rootSDK = {
    version : version,
    getHostModule: exposeGlobally(getHostModule),
    getIframeModule: exposeGlobally(getIframeModule),
    getWebcomponentModule: exposeGlobally(getWebcomponentModule),
    getMyopMessages: exposeGlobally(getMyopMessages),
    getMyopHelpers: exposeGlobally(getMyopHelpers)
};

// @ts-ignore
if (!window.myop) {
    // @ts-ignore
    window.myop = {
        __ROOT_SDK_PUBLIC_URL__
    }
}

// @ts-ignore
if (!window.myop.rootSDK) {
    // @ts-ignore
    window.myop = {
        // @ts-ignore
        rootSDK,
        ...window.myop
    };
} else {
    console.log("myop root host loaded more than once.");
}

// For bundlers usage :
const sdkModule = {
    getHostModule,
    getIframeModule,
    getWebcomponentModule
}
export type rootSDKType = typeof sdkModule;

export {
    getHostModule,
    getIframeModule,
    getWebcomponentModule
}

// declare global {
//     interface Window {
//         myop: {
//             rootSDK: typeof rootSDK
//         }
//     }
// }
